import './leasing-offers.scss';

import { ErrorBoundary } from 'react-error-boundary';

import { useAppSelector } from '@/store';
import type { TAutoCredLeasingResponse } from '@/types/newOrder';

import { LeasingDeclinedItem, LeasingWaitingItem } from '../../entities';
import { LeasingApprovedItem } from '../../features';
import { LeasingOffersError } from '../../ui';

type TProps = {
  approvedOffers: TAutoCredLeasingResponse[];
  waitingOffers: TAutoCredLeasingResponse[];
  declinedOffers: TAutoCredLeasingResponse[];
};

const LeasingOffers = ({
  approvedOffers,
  waitingOffers,
  declinedOffers
}: TProps) => {
  const { banksOffers } = useAppSelector((state) => state.offerStep);

  const hasOfferedBankResponse: boolean =
    banksOffers.find((item) => item.isOffered) !== undefined;

  const onlyErrorResponses: boolean =
    declinedOffers.length > 0 &&
    approvedOffers.length === 0 &&
    waitingOffers.length === 0;

  return (
    <div key="leasing-offers" id="leasing-offers" className="leasing-offers">
      {approvedOffers.length === 0 &&
        waitingOffers.length === 0 &&
        declinedOffers.length === 0 && (
          <div className="leasing-offers__empty">Нет предложений</div>
        )}

      {approvedOffers.length > 0 &&
        approvedOffers.map((leasing) => (
          <ErrorBoundary
            FallbackComponent={(props) => (
              <LeasingOffersError {...props} leasingOffer={leasing} />
            )}
            key={leasing.uuid}
          >
            <LeasingApprovedItem
              leasingOffer={leasing}
              hasOfferedBankResponse={hasOfferedBankResponse}
            />
          </ErrorBoundary>
        ))}

      {waitingOffers.length > 0 &&
        waitingOffers.map((leasing) => (
          <LeasingWaitingItem leasingOffer={leasing} key={leasing.uuid} />
        ))}

      {declinedOffers.length > 0 && (
        <div>
          {!onlyErrorResponses && (
            <h1 className="leasing-offers__declined-title"></h1>
          )}
          {declinedOffers.map((leasing) => (
            <LeasingDeclinedItem leasingOffer={leasing} key={leasing.uuid} />
          ))}
        </div>
      )}
    </div>
  );
};

export default LeasingOffers;
